// import { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import PropTypes from 'prop-types';
// import AppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
// import Icon from '@mui/material/Icon';
// import { useDispatch, useSelector } from 'react-redux';
// import { useAuthenticator } from '@aws-amplify/ui-react';
// import { resetIsLogout } from '../store/logoutSlice';

// // --- styled components from your setup ---
// import { TitleTypography, ProfileBox } from 'components/Ui/styled';
// import { useMaterialUIController, setTransparentNavbar } from 'context';
// import routes from 'routes';

// function DashboardNavbar({ absolute, light }) {
//   const dashboardDetails = useSelector((state) => state?.dashboard);
//   const userName = dashboardDetails?.username;
//   const dispatchUse = useDispatch();
//   const navigate = useNavigate();
//   const [navbarType, setNavbarType] = useState('static');
//   const [controller, dispatch] = useMaterialUIController();
//   const { transparentNavbar, fixedNavbar, darkMode } = controller;
//   const { signOut } = useAuthenticator((context) => [context.user]);

//   // Menu states
//   const [anchorElNav, setAnchorElNav] = useState(null);
//   const [profileMenu, setProfileMenu] = useState(null);

//   const route = useLocation().pathname.split('/').slice(1);

//   useEffect(() => {
//     if (fixedNavbar) setNavbarType('sticky');
//     else setNavbarType('static');

//     function handleTransparentNavbar() {
//       setTransparentNavbar(
//         dispatch,
//         (fixedNavbar && window.scrollY === 0) || !fixedNavbar
//       );
//     }

//     window.addEventListener('scroll', handleTransparentNavbar);
//     handleTransparentNavbar();

//     return () => window.removeEventListener('scroll', handleTransparentNavbar);
//   }, [dispatch, fixedNavbar]);

//   // Responsive nav handlers
//   const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
//   const handleCloseNavMenu = (routePath) => {
//     setAnchorElNav(null);
//     if (routePath) navigate(routePath);
//   };

//   // Profile menu handlers
//   const handleClickProfile = (event) => setProfileMenu(event.currentTarget);
//   const handleCloseProfile = () => setProfileMenu(null);

//   const handleSignOut = () => {
//     navigate('/');
//     signOut();
//     setTimeout(() => dispatchUse(resetIsLogout()), 2000);
//   };

//   // Flatten routes (so nested collapse menus also show up)
//   const extractMenuRoutes = (allRoutes) => {
//     let menuItems = [];
//     allRoutes.forEach((r) => {
//       if (r.collapse) {
//         menuItems = [...menuItems, ...extractMenuRoutes(r.collapse)];
//       } else if (r.route && r.name) {
//         menuItems.push({ name: r.name, route: r.route, key: r.key });
//       }
//     });
//     return menuItems;
//   };
//   const menuRoutes = extractMenuRoutes(routes);

//   return (
//     <AppBar
//       position={absolute ? 'absolute' : navbarType}
//       color="primary"
//       sx={{ px: 2 }}
//     >
//       <Toolbar disableGutters>
//         {/* Logo / Title */}
//         <Typography
//           variant="h6"
//           noWrap
//           component="div"
//           sx={{ flexGrow: 1, cursor: 'pointer' }}
//           onClick={() => navigate('/dashboard')}
//         >
//           Delta Student & Parent
//         </Typography>

//         {/* Desktop Menu */}
//         <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
//           {menuRoutes.map((page) => (
//             <Button
//               key={page.key}
//               onClick={() => handleCloseNavMenu(page.route)}
//               sx={{ color: 'white' }}
//             >
//               {page.name}
//             </Button>
//           ))}
//         </Box>

//         {/* Mobile Hamburger */}
//         <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
//           <IconButton
//             size="large"
//             aria-label="menu"
//             onClick={handleOpenNavMenu}
//             color="inherit"
//           >
//             <Icon>menu</Icon>
//           </IconButton>
//           <Menu
//             anchorEl={anchorElNav}
//             open={Boolean(anchorElNav)}
//             onClose={() => handleCloseNavMenu(null)}
//           >
//             {menuRoutes.map((page) => (
//               <MenuItem
//                 key={page.key}
//                 onClick={() => handleCloseNavMenu(page.route)}
//               >
//                 <Typography textAlign="center">{page.name}</Typography>
//               </MenuItem>
//             ))}
//           </Menu>
//         </Box>

//         {/* Profile Menu */}
//         <ProfileBox color={light ? 'white' : 'inherit'}>
//           {userName && <TitleTypography>{userName}</TitleTypography>}
//           <IconButton onClick={handleClickProfile} size="small" color="inherit">
//             <Icon>account_circle</Icon>
//           </IconButton>
//           <Menu
//             anchorEl={profileMenu}
//             open={Boolean(profileMenu)}
//             onClose={handleCloseProfile}
//           >
//             <MenuItem onClick={handleSignOut}>Logout</MenuItem>
//           </Menu>
//         </ProfileBox>
//       </Toolbar>
//     </AppBar>
//   );
// }

// DashboardNavbar.defaultProps = {
//   absolute: false,
//   light: false,
// };

// DashboardNavbar.propTypes = {
//   absolute: PropTypes.bool,
//   light: PropTypes.bool,
// };

// export default DashboardNavbar;

import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { resetIsLogout } from '../store/logoutSlice';
import deltaLogo from 'assets/images/deltaSnp/logo_Delta-Academy-web.png';

// --- styled components from your setup ---
import { useMaterialUIController, setTransparentNavbar } from 'context';
import routes from 'routes';
import { Grid } from '@mui/material';
// import { getMatchingSubjects } from 'layouts/tutoring/utils/subjectMatching';

function DashboardNavbar({ absolute, light }) {
  const dashboardDetails = useSelector((state) => state?.dashboard);
  const tutoringSubjects = useSelector(
    (state) => state?.tutoringSubjects?.subjects
  );
  // const courses = useSelector((state) => state?.dashboard?.courses);
  const { firstName, lastName } = dashboardDetails?.profile || {}
  // const userName = dashboardDetails?.username;
  const userName = `${firstName} ${lastName}`;
  const dispatchUse = useDispatch();
  const navigate = useNavigate();
  const [navbarType, setNavbarType] = useState('static');
  const [controller, dispatch] = useMaterialUIController();
  const { fixedNavbar } = controller;
  const { signOut } = useAuthenticator((context) => [context.user]);

  // Menu states
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [profileMenu, setProfileMenu] = useState(null);

  // useEffect(() => {
  //   // if (isSideNav) {
  //   const script = document.createElement('script');
  //   script.src = '/js/chatbot.js';
  //   script.async = true;

  //   script.onload = () => {
  //     let sessionId = localStorage.getItem(`chat_session_${userName}`);
  //     if (!sessionId) {
  //       sessionId = `user_${userName}`;
  //       localStorage.setItem(`chat_session_${userName}`, sessionId);
  //     }
  //     window.navigateWithoutReload = (url) => {
  //       window.location.href = `${window.location.origin}${url}${
  //         url.includes('?') ? '&' : '?'
  //       }keepChatOpen=true`;
  //     };

  //     window.initChatbot({
  //       userId: userName,
  //       authToken: authToken,
  //       userName: `${userName}`,
  //       sessionId: sessionId,
  //       companyName: 'DELTA',
  //       apiUrl:
  //         'https://p83t6tm7vc.execute-api.us-east-1.amazonaws.com/prod/chat',
  //       baseUrl: 'https://dev.dacs-lv.com/',
  //       suggestedQuestions: [
  //         'How can I schedule a session?',
  //         'What subjects do you offer?',
  //         'How can I contact a tutor?',
  //       ],
  //       theme: {
  //         primaryColor: '#2e4e72',
  //         secondaryColor: '#573175',
  //         textColor: '#333333',
  //         backgroundColor: '#ffffff',
  //         fontFamily:
  //           '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  //       },
  //     });
  //   };

  //   document.body.appendChild(script);

  //   return () => {
  //     // Clean up chatbot when component unmounts or user logs out
  //     if (window.cleanupChatbot) {
  //       window.cleanupChatbot();
  //     }
  //   };
  //   // }
  // }, [userName, authToken, userName]);

  useEffect(() => {
    if (fixedNavbar) setNavbarType('sticky');
    else setNavbarType('static');

    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    window.addEventListener('scroll', handleTransparentNavbar);
    handleTransparentNavbar();

    return () => window.removeEventListener('scroll', handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  // Responsive nav handlers
  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleCloseNavMenu = (routePath) => {
    setAnchorElNav(null);
    if (routePath) navigate(routePath);
  };

  // Profile menu handlers
  const handleClickProfile = (event) => setProfileMenu(event.currentTarget);
  const handleCloseProfile = () => setProfileMenu(null);

  const handleSignOut = () => {
    navigate('/');
    signOut();
    setTimeout(() => dispatchUse(resetIsLogout()), 2000);
  };

  // Flatten routes (so nested collapse menus also show up)
  const extractMenuRoutes = (allRoutes) => {
    let menuItems = [];
    allRoutes.forEach((r) => {
      if (r.collapse) {
        menuItems = [...menuItems, ...extractMenuRoutes(r.collapse)];
      } else if (r.route && r.name) {
        menuItems.push({ name: r.name, route: r.route, key: r.key });
      }
    });
    return menuItems;
  };
  const menuRoutes = extractMenuRoutes(routes).filter(
    (page) =>
      page.key !== 'tutoring' ||
      // getMatchingSubjects(courses, tutoringSubjects)?.length > 0
      tutoringSubjects?.length > 0
  );

  const location = useLocation();

  const isActive = (routePath) => {
    return location.pathname === routePath;
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        borderRadius: '12px',
        overflow: 'hidden',
        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      {/* Upper Header with Logo and Username */}
      {/* <Box
        sx={{
          backgroundColor: 'white',
          px: 3,
          py: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
        }}
      > */}
      {/* Logo Section */}
      {/* <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => navigate('/dashboard')}
        >
          <Box
            component="img"
            src={deltaLogo}
            alt="Delta Academy Logo"
            sx={{
              width: 32,
              height: 32,
              borderRadius: '6px',
              mr: 2,
              objectFit: 'contain',
            }}
          />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              fontWeight: 600,
              fontSize: '16px',
              color: '#333',
              letterSpacing: '0.5px',
            }}
          >
            THE DELTA ACADEMY
          </Typography>
        </Box> */}

      {/* Username and Profile Section */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {userName && (
            <Typography
              sx={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 500,
                mr: 1,
              }}
            >
              {userName}
            </Typography>
          )}
          <IconButton
            onClick={handleClickProfile}
            size="small"
            sx={{
              color: '#333',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <Icon>account_circle</Icon>
          </IconButton>
          <Menu
            anchorEl={profileMenu}
            open={Boolean(profileMenu)}
            onClose={handleCloseProfile}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiPaper-root': {
                // backgroundColor: 'white',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                minWidth: '120px',
              },
            }}
          >
            <MenuItem
              onClick={handleSignOut}
              sx={{
                fontSize: '14px',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Box> */}
      {/* </Box> */}

      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          backgroundColor: '#ffffff',
          px: 3,
          py: 1,
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        {/* Logo + Title */}
        <Grid
          item
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={() => navigate('/dashboard')}
        >
          <img
            src={deltaLogo}
            alt="Delta Academy Logo"
            style={{
              width: 32,
              height: 32,
              borderRadius: 6,
              marginRight: 8,
              objectFit: 'contain',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: 16,
              color: '#333',
              letterSpacing: '0.5px',
            }}
          >
            THE DELTA ACADEMY
          </Typography>
        </Grid>

        {/* Username + Profile */}
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          {userName && (
            <Typography
              sx={{ color: '#333', fontSize: 14, fontWeight: 500, mr: 1 }}
            >
              {userName}
            </Typography>
          )}
          <IconButton
            onClick={handleClickProfile}
            size="small"
            sx={{ color: '#333', p: 0.5 }}
          >
            <Icon>account_circle</Icon>
          </IconButton>
          <Menu
            anchorEl={profileMenu}
            open={Boolean(profileMenu)}
            onClose={handleCloseProfile}
            disableScrollLock={true}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{
              '& .MuiPaper-root': {
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                minWidth: '120px',
              },
            }}
          >
            <MenuItem onClick={handleSignOut} sx={{ fontSize: 14 }}>
              Logout
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>

      {/* Navigation Bar */}
      <AppBar
        data-testid="appbar"
        position={absolute ? 'absolute' : navbarType}
        sx={{
          color: 'white',
          backgroundColor: '#4A90E2',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          px: 0,
          position: 'static',
          mb: 2,
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px',
        }}
      >
        <Toolbar
          data-testid="toolbar"
          disableGutters
          sx={{
            minHeight: '48px !important',
            justifyContent: 'center',
            paddingLeft: '24px',
            paddingRight: '24px',
          }}
        >
          {/* Desktop Menu */}
          <Box
            data-testid="Box"
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
            }}
          >
            {menuRoutes.map((page) => (
              <Button
                data-testid="Button"
                key={page.key}
                onClick={() => handleCloseNavMenu(page.route)}
                style={{
                  // color: 'white',
                  color: isActive(page.route) ? '#4A90E2' : 'white', // 🔹 Active text color
                  backgroundColor: isActive(page.route)
                    ? 'rgba(255, 255, 255, 0.9)' // 🔹 Active bg
                    : 'transparent',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
                sx={{
                  color: 'white',
                  mx: 1,
                  px: 3,
                  py: 1,
                  fontSize: '14px',
                  fontWeight: 500,
                  textTransform: 'none',
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                  '&.active': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  },
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>

          {/* Mobile Hamburger */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              <Icon>menu</Icon>
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={() => handleCloseNavMenu(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiPaper-root': {
                  backgroundColor: 'white',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  minWidth: '200px',
                },
              }}
            >
              {menuRoutes.map((page) => (
                <MenuItem
                  key={page.key}
                  onClick={() => handleCloseNavMenu(page.route)}
                  sx={{
                    fontSize: '14px',
                    '&:hover': {
                      backgroundColor: '#eabdbdff',
                    },
                  }}
                >
                  <Typography style={{ color: '#ffffff' }} textAlign="center">
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
};

export default DashboardNavbar;
